import { cn } from '@utils/shad-utils'
import type React from 'react'

export interface HeaderProps {
  title: string
  /** Adds accent background */
  accent?: boolean
  /** Renders a left accent bar */
  borderLeft?: boolean
  /** Heading level to render. Defaults to 'h1' */
  as?: 'h1' | 'h2' | 'h3'
  className?: string
}

export const Header: React.FC<HeaderProps> = ({
  title,
  accent = false,
  borderLeft = false,
  as: Heading = 'h1',
  className,
}) => {
  const containerClass = cn('flex items-center gap-x-4', className)
  const titleClass = cn(accent && 'text-primary', borderLeft && 'text-viken-spruce-700')

  return (
    <div className={containerClass}>
      {borderLeft && <div className="w-[3px] h-[28px] bg-viken-shoots-500 rounded-full" />}
      <Heading className={titleClass}>{title}</Heading>
    </div>
  )
}

export default Header
